import { render, staticRenderFns } from "./TechnicalTextBlock.vue?vue&type=template&id=69879943&scoped=true&"
import script from "./TechnicalTextBlock.vue?vue&type=script&lang=js&"
export * from "./TechnicalTextBlock.vue?vue&type=script&lang=js&"
import style0 from "./TechnicalTextBlock.vue?vue&type=style&index=0&id=69879943&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69879943",
  null
  
)

export default component.exports